import React, { useContext, useEffect } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { NotificaçõesContext } from 'contexts/NotificaçõesContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { VendaContext } from 'contexts/VendaContext';
import { DropsContext } from 'contexts/DropsContext';
import { useDialog } from 'components/Modals';
import Navbar from 'components/Navbar';
import RelatorioModal from 'components/Modals/RelatorioModal';
import Routes from 'routes';

const styles = {
  main: {
    height: '100vh',
  },
  container: {
    padding: '88px 24px 0 24px',
  },
};

const App = () => {
  const { getDrops } = useContext(DropsContext);
  const { getContas } = useContext(VendaContext);
  const { relatorio } = useContext(RelatoriosContext);
  const { getNotifications } = useContext(NotificaçõesContext);
  const { openDialog } = useDialog();

  useEffect(() => {
    getContas();
    getNotifications();
    getDrops([
      'Ccusto',
      'Cidade',
      'Contrato',
      'Contribuinte',
      'Defeito',
      'Equipamento',
      'Entidade',
      'EntidadeTipo',
      'EspecieDocumento',
      'Filial',
      'FormaDePagamento',
      'LocalEstoque',
      'Logo',
      'Marca',
      'Modelo',
      'Modelofiscal',
      'NaturezaOperacao',
      'Produto',
      'Serie',
      'Tecnico',
      'UF',
      'UnidadeMedida',
      'Users',
    ]);
  }, []);

  useEffect(() => {
    if (relatorio) {
      openDialog(<RelatorioModal relatorio={relatorio} />, relatorio?.nome);
    }
  }, [relatorio]);

  return (
    <div style={styles.main}>
      <Navbar />
      <Scrollbars>
        <div style={styles.container}>
          <Routes />
        </div>
      </Scrollbars>
    </div>
  );
};

export default App;
